// extracted by mini-css-extract-plugin
export default {"mobileSearch":"FiltersLayout_mobileSearch__I1ePJ"};